<template>
    <div class="loader-wrap">
        <span class="loader-2"></span>
    </div>
</template>